import workspaceQuery from '../../../graphql/queries/bank/BankFeedRuleWorkspaceQuery.graphql';
import instanceQuery from '../../../graphql/queries/bank/BankFeedRuleQuery.graphql';
import defaultQuery from '../../../graphql/queries/bank/BankFeedRuleDefault.graphql';
import mutationQuery from '../../../graphql/mutations/bank/BankFeedRuleMutation.graphql';
import temporaryMutationQuery from '../../../graphql/mutations/bank/SaveBankFeedRuleTempMutation.graphql';
import fragment from '../../../graphql/fragments/bank/BankFeedRuleFragment.graphql';

const BankFeedRule = {
  type: 'BankFeedRule',
  title: 'Bank Feed Rules',
  formUrl: '/Bank/FeedRule/Details/',
  formTitle: 'Bank Feed Rule',
  workspaceUrl: '/Bank/FeedRule/Workspace/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  default: defaultQuery,
  update: mutationQuery,
  temporarySave: temporaryMutationQuery,
  fragment,
  screenReference: 'BANK_FEEDRULE',
};

export default BankFeedRule;
